if (!customElements.get('tabbed-content')) {
  class Tabs extends HTMLElement {
    constructor() {
      super();
      this.tabList = this.querySelector('[role="tablist"]');
      if (!this.tabList) return; // niente tablist → esci

      this.tabs = Array.from(this.querySelectorAll('[role="tab"]'));
      this.panels = Array.from(this.querySelectorAll('[role="tabpanel"]'));
      this.activeTab = this.tabList.querySelector('[aria-selected="true"]') || this.tabs[0];

      // Imposta stato iniziale: per ogni tab prova a trovare il pannello corrispondente.
      this.tabs.forEach(tab => {
        const panelId = tab.getAttribute('aria-controls');
        const panel = panelId ? document.getElementById(panelId) : null;

        if (tab === this.activeTab) {
          tab.setAttribute('aria-selected', 'true');
          tab.removeAttribute('tabindex');
          if (panel) panel.hidden = false;
        } else {
          tab.setAttribute('aria-selected', 'false');
          tab.setAttribute('tabindex', '-1');
          if (panel) panel.hidden = true;
        }
      });

      this.isVerticalTablist = this.tabList.getAttribute('aria-orientation') === 'vertical';

      this.addListeners();
    }

    addListeners() {
      this.tabList.addEventListener('click', (evt) => {
        const tab = evt.target.closest('[role="tab"]');
        if (!tab || tab === this.activeTab) return;
        this.activateTab(tab);
      });

      this.tabList.addEventListener('keydown', (evt) => {
        const key = evt.key;
        if (['ArrowLeft','ArrowRight','ArrowUp','ArrowDown','Home','End'].includes(key)) {
          evt.preventDefault();
          this.handleKey(key);
        }
      });
    }

    handleKey(key) {
      const length = this.tabs.length;
      const currentIndex = this.tabs.indexOf(this.activeTab);
      if (currentIndex === -1) return;

      let newIndex = currentIndex;
      switch (key) {
        case 'ArrowRight':
        case 'ArrowDown':
          newIndex = (currentIndex + 1) % length;
          break;
        case 'ArrowLeft':
        case 'ArrowUp':
          newIndex = (currentIndex - 1 + length) % length;
          break;
        case 'Home':
          newIndex = 0;
          break;
        case 'End':
          newIndex = length - 1;
          break;
      }
      this.activateTab(this.tabs[newIndex]);
    }

    activateTab(tab) {
      if (!tab || tab === this.activeTab) return;

      // nascondi pannello precedente (se esiste)
      if (this.activeTab) {
        const oldPanelId = this.activeTab.getAttribute('aria-controls');
        const oldPanel = oldPanelId ? document.getElementById(oldPanelId) : null;
        if (oldPanel) oldPanel.hidden = true;
        this.activeTab.setAttribute('aria-selected', 'false');
        this.activeTab.setAttribute('tabindex', '-1');
      }

      // mostra pannello nuovo (se esiste)
      const newPanelId = tab.getAttribute('aria-controls');
      const newPanel = newPanelId ? document.getElementById(newPanelId) : null;
      if (newPanel) newPanel.hidden = false;

      tab.setAttribute('aria-selected', 'true');
      tab.removeAttribute('tabindex');

      this.activeTab = tab;
      try { tab.focus(); } catch (e) {}
    }
  }

  customElements.define('tabbed-content', Tabs);
}
